import { PickEstablishmentModalContainer } from "../../modals/PickEstablishmentModal/PickEstablishmentModalContainer";
import { CreateCertificateModalContainer } from "../../modals/CreateCertificateModal/CreateCertificateModalContainer";
import { EditCertificateModalContainer } from "../../modals/EditCertificateModal/EditCertificateModalContainer";
import { CreateEmployeeModalContainer } from "../../modals/CreateEmployeeModal/CreateEmployeeModalContainer";
import { EditEmployeeModalContainer } from "../../modals/EditEmployeeModal/EditEmployeeModalContainer";
import { DeactivateEmployeeConfirmationModalContainer } from "../../modals/DeactivateEmployeeConfirmationModal/DeactivateEmployeeConfirmationModalContainer";
import { UpsertScheduleQualificationModalContainer } from "../../modals/UpsertScheduleQualificationModal/UpsertScheduleQualificationModalContainer";
import { useAppSelector } from "../../app/hooks";
import { useIsEstablishmentManager } from "../utils/useIsEstablishmentManager";
import { JSX } from "react";

export const LoadModals = (): JSX.Element => {
    const isEstablishmentManager = useIsEstablishmentManager();

    const {
        isCreateCertificateModalOpen,
        isEditCertificateModalOpen,
        isCreateEmployeeModalOpen,
        isEditEmployeeModalOpen,
        isPickEstablishmentModalOpen,
        isDeactivateEmployeeConfirmationModalOpen,
        isScheduleQualificationModalOpen,
    } = useAppSelector((state) => ({
        isCreateCertificateModalOpen:
            state.createCertificateModal.isCreateCertificateModalOpen,
        isEditCertificateModalOpen:
            state.editCertificateModal.isEditCertificateModalOpen,
        isCreateEmployeeModalOpen:
            state.createEmployeeModal.isCreateEmployeeModalOpen,
        isEditEmployeeModalOpen:
            state.editEmployeeModal.isEditEmployeeModalOpen,
        isPickEstablishmentModalOpen:
            state.pickEstablishmentModal.isPickEstablishmentModalOpen,
        isDeactivateEmployeeConfirmationModalOpen:
            state.deactivateEmployeeConfirmationModal
                .isDeactivateEmployeeConfirmationModalOpen,
        isScheduleQualificationModalOpen:
            state.upsertScheduleQualificationModal
                .isScheduleQualificationModalOpen,
    }));

    return (
        <>
            {isEstablishmentManager && isPickEstablishmentModalOpen && (
                <PickEstablishmentModalContainer />
            )}
            {isCreateCertificateModalOpen && (
                <CreateCertificateModalContainer />
            )}
            {isEditCertificateModalOpen && <EditCertificateModalContainer />}
            {isCreateEmployeeModalOpen && <CreateEmployeeModalContainer />}
            {isEditEmployeeModalOpen && <EditEmployeeModalContainer />}
            {isDeactivateEmployeeConfirmationModalOpen && (
                <DeactivateEmployeeConfirmationModalContainer />
            )}
            {isScheduleQualificationModalOpen && (
                <UpsertScheduleQualificationModalContainer />
            )}
        </>
    );
};
